export const types = {
  GET_DEVICES: 'FORM/GET_DEVICES',
  SET_DEVICES: 'FORM/SET_DEVICES',
};

export const actions = {
  getDevices: (data) => ({
    type: types.GET_DEVICES,
    payload: { data },
  }),
  setDevices: (data) => ({
    type: types.SET_DEVICES,
    payload: { data },
  }),
};

const initialState = {
  devices: null,
  searchingDevices: false,
  transactionData: null,
  isLoadingTransaction: false,
  transactionError: null,
};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case types.GET_DEVICES: {
      return {
        ...state,
        searchingDevices: true,
      };
    }
    case types.SET_DEVICES: {
      const { data } = { ...action.payload };
      const { devices = [] } = {
        ...data,
      };
      return {
        ...state,
        devices,
        searchingDevices: false,
      };
    }
    default:
      return state;
  }
}

export default reducer;
